import { DataTable, DataTableColumn, DataTableRow } from '@/console/ui/DataTable'
import { Tag } from '@/console/ui/Tag'
import { Button } from '@/console/ui/Button'
import { HoldRuleRow } from './holdRows'

/** 시안 `#s-disp-5` 표 이식. 행 계산은 `holdRows.ts` 가 끝낸 값을 그대로 그린다. */
export type HoldRuleTableProps = {
  rows: HoldRuleRow[]
  onRequestDelete: (row: HoldRuleRow) => void
  /** 다른 조치가 진행 중이면 잠근다 — 눌러도 조용히 버려지는 것보다 눌리지 않는 편이 낫다(PR 리뷰). */
  disabled?: boolean
}

const COLUMNS: DataTableColumn[] = [
  { key: 'rule', label: '규칙' },
  { key: 'target', label: '적용 대상' },
  { key: 'period', label: '기간', mono: true },
  { key: 'reason', label: '사유' },
  { key: 'action', label: '' },
]

export const HoldRuleTable = ({ rows, onRequestDelete, disabled = false }: HoldRuleTableProps): JSX.Element => {
  const tableRows: DataTableRow[] = rows.map((row) => {
    const [periodFrom, periodUntil] = row.period.split(' → ')

    return {
      key: row.key,
      muted: row.expired,
      cells: {
        rule: (
          <>
            <Tag tone={row.tone}>{row.typeLabel}</Tag>
            {row.autoGenerated ? (
              <>
                {' '}
                <Tag tone="neutral">자동 생성</Tag>
              </>
            ) : null}
            <div style={{ fontFamily: 'var(--mono)', fontSize: 12.5, marginTop: 5 }}>{row.holdId}</div>
          </>
        ),
        target: row.target,
        period: (
          <>
            {periodFrom}
            <br />→ {periodUntil}
          </>
        ),
        reason: row.reason,
        action: (
          <Button variant="line" size="sm" disabled={row.autoGenerated || disabled} onClick={() => onRequestDelete(row)}>
            해제
          </Button>
        ),
      },
    }
  })

  return <DataTable columns={COLUMNS} rows={tableRows} />
}
